import React from 'react'

import Line from '../base/Line'
import Square from '../base/Square'

import s from './ProductCard.scss'


const ProductCard = () => (
  <div className={s.card}>
    <Square className={s.image} />
    <Line className={s.title} />
    <Line className={s.subTitle} />
    <Line className={s.text} />
  </div>
)


export default ProductCard
